/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Status_NoneInputs */

const vi_irrigation_schedule_status_none = /** @type {(inputs: Irrigation_Schedule_Status_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa áp dụng lịch nào, bơm chỉ bật/tắt tay.`)
};

/**

* @param {Irrigation_Schedule_Status_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_status_none = /** @type {((inputs?: Irrigation_Schedule_Status_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Status_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_status_none(inputs)
});